function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#4A4A4A",
  fillRule: "nonzero",
  d: "M15 5.333A2.672 2.672 0 0 0 12.333 8 2.672 2.672 0 0 0 15 10.667 2.672 2.672 0 0 0 17.667 8 2.672 2.672 0 0 0 15 5.333zM7.667 11a1.335 1.335 0 0 0 .55 1.804L12.334 15v3.073l-1.968 4.146a1.337 1.337 0 1 0 2.415 1.145l1.908-4.03h.625l1.907 4.03a1.336 1.336 0 1 0 2.415-1.144v-.001l-1.968-4.146V15l4.115-2.196c.65-.346.897-1.154.551-1.804a1.33 1.33 0 0 0-1.8-.55L17 12.333h-4L9.468 10.45a1.33 1.33 0 0 0-1.801.55z"
}), React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 13.75,
  stroke: "#4A4A4A",
  strokeWidth: 2.5
}));

var SvgAccessibilityBenefit = function SvgAccessibilityBenefit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAccessibilityBenefit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/accessibility-benefit.0decb94e.svg";
export { ForwardRef as ReactComponent };